import "../style/global.css";
import Logo from "../assets/full-logo.png";

const Footer = () => {

  return (
    <div className={'footer'}>
      <img className={'footer-logo'} src={Logo} alt={'BLUESKI'}/>
      <div className={'footer-info'}>
        <div className={'footer-info-col'}>
          <div className={'footer-info-row'}>
            <div className={'footer-label'}>회사명</div>
            <div className={'footer-value'}>블루스키스쿨</div>
          </div>
          <div className={'footer-info-row'}>
            <div className={'footer-label'}>대표자</div>
            <div className={'footer-value'}>윤봉열 | 나경민</div>
          </div>
        </div>
        <div className={'footer-info-row'}>
          <div className={'footer-label'}>이메일</div>
          <div className={'footer-value'}>blueski9598@naver.com</div>
        </div>
        <div className={'footer-info-row'}>
          <div className={'footer-label'}>사업자등록번호</div>
          <div className={'footer-value'}>639-20-02537</div>
        </div>
        <div className={'footer-info-row'}>
          <div className={'footer-label'}>문의·전화상담</div>
          <div className={'footer-value'}>010-7772-9598</div>
        </div>
      </div>
    </div>
  )
}

export default Footer;